
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Footer extends Vue {
  scrollToTop() {
    document.body.getElementsByTagName('s-page')[0].scrollTop = 0
  }
}
